import React from "react";
import { Link } from "react-router-dom";
import "../styles/pages.css";

export default function CreativeIntelligenceSession() {
  React.useEffect(() => { window.scrollTo({ top: 0 }); }, []);
  return (
    <div className="kmr-page case-study-wrap" data-testid="creative-intelligence-page">
      <div className="case-back">
        <Link to="/" data-testid="cis-back-link">← Back to Komorebi</Link>
      </div>
      <iframe
        title="The Creative Intelligence Session — Komorebi"
        src="/creative-intelligence-session.html"
        className="case-study-iframe"
        data-testid="creative-intelligence-iframe"
      />
    </div>
  );
}
